var map = {
	"./pg/BI_SCP_CloudMonitoring_light.svg": "./src/assets/img/scmp/customerLogo/pg/BI_SCP_CloudMonitoring_light.svg",
	"./pp/BI_SCP_CloudMonitoring_light.svg": "./src/assets/img/scmp/customerLogo/pp/BI_SCP_CloudMonitoring_light.svg",
	"./ps/BI_SCP_CloudMonitoring_light.svg": "./src/assets/img/scmp/customerLogo/ps/BI_SCP_CloudMonitoring_light.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/scmp/customerLogo sync recursive ^\\.\\/.*\\/BI_SCP_CloudMonitoring_light\\.svg$";